import React from 'react';
import PropTypes from 'prop-types';

import { Accordion as MUIAccordion } from '@mui/material';

export const Accordion = props => <MUIAccordion {...props} />;

Accordion.propTypes = {
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.object,
  classes: PropTypes.object,
  defaultExpanded: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  square: PropTypes.bool
};

export default Accordion;
